/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExamTypeVm,
    ExamTypeVmFromJSON,
    ExamTypeVmFromJSONTyped,
    ExamTypeVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExamTypeVmPaginatedSearchResponse
 */
export interface ExamTypeVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<ExamTypeVm>}
     * @memberof ExamTypeVmPaginatedSearchResponse
     */
    items?: Array<ExamTypeVm> | null;
    /**
     * 
     * @type {number}
     * @memberof ExamTypeVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamTypeVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamTypeVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamTypeVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamTypeVmPaginatedSearchResponse
     */
    size?: number;
}

export function ExamTypeVmPaginatedSearchResponseFromJSON(json: any): ExamTypeVmPaginatedSearchResponse {
    return ExamTypeVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function ExamTypeVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamTypeVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(ExamTypeVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function ExamTypeVmPaginatedSearchResponseToJSON(value?: ExamTypeVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(ExamTypeVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


